import React, {useContext} from "react"
import Row from "@amzn/meridian/row";
import StageStatusView from "./StageStatusView";
import {RouteStageContext} from "./context/RouteStageContext";

const StageOverallStatus = () => {

    const {viewModel} = useContext(RouteStageContext)

    return (
        <div>
            {/* FIRST ROW */}
            <Row widths={["grid-3", "grid-3", "grid-3"]} spacingInset="large">
                <StageStatusView stageStatus={{
                    title: "stageOverall.totalRoutes",
                    message: "Total Routes",
                    value: viewModel.totalRoutes
                }}/>
                <StageStatusView stageStatus={{
                    title: "stageOverall.routesStaged",
                    message: "Routes Staged",
                    value: viewModel.stagedRoutes
                }}/>
                <StageStatusView stageStatus={{
                    title: "stageOverall.routesDeparted",
                    message: "Routes Departed",
                    value: viewModel.departedRoutes
                }}/>
            </Row>


            {/* SECOND ROW */}
            <Row widths={["grid-3", "grid-3", "grid-3", "grid-3"]} spacingInset="large">
                <StageStatusView stageStatus={{
                    title: "stageOverall.cartsStaged",
                    message: "Carts Staged",
                    value: viewModel.stagedCarts
                }}/>
                <StageStatusView stageStatus={{
                    title: "stageOverall.cartDwellingDSP",
                    message: "Carts Dwelling (DSP)",
                    value: viewModel.dwellingCartsDSP
                }}/>
                <StageStatusView stageStatus={{
                    title: "stageOverall.cartDwellingFlex",
                    message: "Carts Dwelling (Flex)",
                    value: viewModel.dwellingCartsFlex
                }}/>
            </Row>
        </div>
    )
}

export default StageOverallStatus


// WEBPACK FOOTER //
// ./src/components/stageStatus/StageOverallStatus.js